import React from 'react';

const FaXmlFileIcon = ({
  backgroundColor = process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? '#171b54' : '#3DA4BC',
  color = '#fff',
  size,
  fontSize,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size || 14} height={size || 18} viewBox="0 0 14 18">
    <g id="Grupo_1866" data-name="Grupo 1866" transform="translate(-1278 -541.572)">
      <g id="Icon_ionic-ios-document" data-name="Icon ionic-ios-document" transform="translate(1270.688 537.635)">
        <path
          id="Caminho_41"
          data-name="Caminho 41"
          d="M21.508,8.664h4.343a.236.236,0,0,0,.239-.239h0a1.412,1.412,0,0,0-.511-1.093L21.938,4.3a1.533,1.533,0,0,0-.983-.353h0A.352.352,0,0,0,20.6,4.3v3.46A.906.906,0,0,0,21.508,8.664Z"
          transform="translate(-4.777 -0.004)"
          fill="#fff"
        />
        <path
          id="Caminho_42"
          data-name="Caminho 42"
          d="M14.819,7.537v-3.6H8.786a1.461,1.461,0,0,0-1.474,1.44V20.5a1.461,1.461,0,0,0,1.474,1.44H19.839a1.461,1.461,0,0,0,1.474-1.44V9.563H16.891A2.052,2.052,0,0,1,14.819,7.537Z"
          transform="translate(0)"
          fill="#fff"
        />
      </g>
      <g id="Grupo_1857" data-name="Grupo 1857" transform="translate(0 1.388)">
        <rect
          id="Retângulo_3005"
          data-name="Retângulo 3005"
          width="12"
          height="6"
          transform="translate(1279 550.612)"
          fill="#5890aa"
        />
        <text
          id="XML"
          transform="translate(1280 555.612)"
          fill="#fff"
          font-size={fontSize || 5}
          font-family="Muli-Bold, Muli"
          font-weight="700"
        >
          <tspan x="0" y="0">
            XML
          </tspan>
        </text>
      </g>
    </g>
  </svg>
);

export default FaXmlFileIcon;
